import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import PeoplevoxCredentialsStore from "../../../stores/credentials/peoplevox-credentials-store";

interface IIntegrationProps {
    credentialsStore: PeoplevoxCredentialsStore,
    vGroup: IValidationGroup,
}

const PeoplevoxCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Peoplevox username' required key='username'>
                <Input
                    value={credentialsStore.username}
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Peoplevox password' required key='password'>
                <Input
                    value={credentialsStore.password}
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Customer code' required key='customer_code'>
                <Input
                    value={credentialsStore.customer_code}
                    onChange={v => credentialsStore.customer_code = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default PeoplevoxCredentials;
